export default "__VITE_ASSET__D4bn9wcp__"